// extracted by css-extract-rspack-plugin
module.exports =  {"template22":"Template22-VwOd__template22","tooltip":"Template22-SFts__tooltip"};